module.exports = __webpack_public_path__ + "static/media/earth-1.8d439632.jpg";